import React from 'react';
import Icon from '../AppIcon';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authService } from '../../services/authService';
import { useNavigate } from 'react-router-dom';

const TabNavigation = () => {
  const location = useLocation();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await authService?.signOut();
      navigate('/signin');
    } catch (err) {
      console.error('Sign out error:', err);
    }
  };

  const tabs = [
    { id: 'welcome', label: 'Welcome', path: '/welcome-onboarding', icon: 'home' },
    { id: 'calendar', label: 'Calendar', path: '/family-calendar-view', icon: 'calendar' },
    { id: 'daily', label: 'Daily Tasks', path: '/daily-task-management', icon: 'list-checks' },
    { id: 'long-term', label: 'Long Term', path: '/long-term-task-planning', icon: 'target' },
    { id: 'team-tasks', label: 'Team Tasks', path: '/multi-member-task-coordination', icon: 'users' },
    { id: 'menu', label: 'Menu', path: '/weekly-menu-planning', icon: 'utensils' },
    { id: 'messages', label: 'Messages', path: '/family-messaging-interface', icon: 'message-circle' },
    { id: 'profile', label: 'Profile', path: '/individual-profile-management', icon: 'user' },
    { id: 'settings', label: 'Settings', path: '/family-settings-management', icon: 'settings' },
    { id: 'help', label: 'Help', path: '/faq-help-center', icon: 'help-circle' },
    { id: 'reports', label: 'Reports', path: '/family-activity-reports', icon: 'bar-chart' }
  ];

  const activeTab = tabs?.find(tab => location?.pathname === tab?.path)?.id || 'welcome';

  return (
    <nav className="bg-card border-b border-border sticky top-0 z-50 shadow-warm-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-1 overflow-x-auto py-2">
            {tabs?.map((tab) => (
              <Link
                key={tab?.id}
                to={tab?.path}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  activeTab === tab?.id
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                <Icon name={tab?.icon} size={18} />
                <span className="hidden sm:inline">{tab?.label}</span>
              </Link>
            ))}
          </div>
          {user && (
            <button
              onClick={handleSignOut}
              className="ml-4 flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
            >
              <Icon name="log-out" size={18} />
              <span className="hidden sm:inline">Sign Out</span>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default TabNavigation;